export default __webpack_public_path__ + "43a3dbd8d265c4be0eac0565cf6b1d74.png";